(() => {
  const KEY = "habitoi:favorites";

  function getFavorites() {
    try {
      const raw = localStorage.getItem(KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch {
      return [];
    }
  }

  function setFavorites(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
  }

  function isFavorite(handle) {
    return getFavorites().includes(handle);
  }

  function addFavorite(handle) {
    const list = getFavorites();
    if (!list.includes(handle)) {
      list.push(handle);
      setFavorites(list);
    }
  }

  function removeFavorite(handle) {
    const list = getFavorites().filter((h) => h !== handle);
    setFavorites(list);
  }

  function setBtnState(btn, active) {
    btn.setAttribute("aria-pressed", active ? "true" : "false");
    btn.classList.toggle("is-active", active);
  }

  function syncButtons(handle, active) {
    document
      .querySelectorAll(`[data-favorite-btn][data-product-handle="${CSS.escape(handle)}"]`)
      .forEach((btn) => setBtnState(btn, active));
  }

  function initButtons() {
    document.querySelectorAll("[data-favorite-btn]").forEach((btn) => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;
      setBtnState(btn, isFavorite(handle));
    });
  }

  // ===== Toast =====
  function ensureToastEl() {
    let el = document.getElementById("habitoi-fav-toast");
    if (!el) {
      el = document.createElement("div");
      el.id = "habitoi-fav-toast";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
      document.body.appendChild(el);
    }
    return el;
  }

  let toastTimer = null;
  function showFavToast(msg) {
    const el = ensureToastEl();
    el.textContent = msg;
    el.classList.add("is-visible");
    if (toastTimer) window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => el.classList.remove("is-visible"), 1800);
  }

  // ===== Page Favoris =====
  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!res.ok) throw new Error("Product fetch failed: " + handle);
    return res.json();
  }

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace(".", ",");
    return `${value} €`;
  }

  async function renderFavoritesPage() {
    const root = document.querySelector("[data-favorites-page]");
    if (!root) return;

    const grid = root.querySelector("[data-favorites-grid]");
    const empty = root.querySelector("[data-favorites-empty]");
    if (!grid) return;

    const handles = getFavorites();

    grid.innerHTML = "";
    if (empty) empty.hidden = handles.length !== 0;
    if (handles.length === 0) return;

    const products = await Promise.allSettled(handles.map(fetchProduct));

    products.forEach((p) => {
      if (p.status !== "fulfilled") return;
      const prod = p.value;

      const img = (prod.images && prod.images.length) ? prod.images[0] : "";
      const card = document.createElement("div");
      card.className = "favorites-card";

      card.innerHTML = `
        <a class="favorites-card__link" href="${prod.url}">
          ${img ? `<img class="favorites-card__img" src="${img}" alt="${prod.title}">` : ""}
          <div class="favorites-card__title">${prod.title}</div>
          <div class="favorites-card__price">${formatMoney(prod.price)}</div>
        </a>
        <button type="button"
          class="favorites-remove"
          data-favorite-btn
          data-product-handle="${prod.handle}"
          aria-pressed="true">
          Retirer
        </button>
      `;

      grid.appendChild(card);
    });
  }

  // ===== Click handler global (CAPTURE) =====
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest("button[data-favorite-btn]");
if (!btn) return;

// On bloque la navigation du lien, mais on ne casse pas Dawn
e.preventDefault();
e.stopPropagation();
// surtout PAS de stopImmediatePropagation()


      const handle = btn.dataset.productHandle;
      if (!handle) return;

      const active = isFavorite(handle);
      if (active) removeFavorite(handle);
      else addFavorite(handle);

      const next = !active;
      syncButtons(handle, next);

      showFavToast(next ? "Ajouté aux favoris" : "Retiré des favoris");

      // Si on est sur la page favoris, on re-render
      if (document.querySelector("[data-favorites-page]")) {
        renderFavoritesPage();
      }
    },
    true // capture
  );

  // Init
  function boot() {
    initButtons();
    renderFavoritesPage();
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
